export enum ENotificationLabels {
  INTERACTIONS = 'interactions',
  MESSAGES = 'messages',
}
